import { render, staticRenderFns } from "./ProgramOrder.vue?vue&type=template&id=589903de&scoped=true"
import script from "./ProgramOrder.vue?vue&type=script&lang=js"
export * from "./ProgramOrder.vue?vue&type=script&lang=js"
import style0 from "./ProgramOrder.vue?vue&type=style&index=0&id=589903de&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "589903de",
  null
  
)

export default component.exports